export const OtherTask1 = () => {

    return (
        <div className="main-container pt-2">
            <section>
                <h1 className="text-center header-main">Задача 1</h1>
                <p className="text-center animated">Создать и опубликовать приложение - телеграм бот. Бот должен поддерживать следующие команды:</p>
                <ul className="list-group">
                    <li className="list-group-item bg-light"><p className="animated">start - приветствие</p></li>
                    <li className="list-group-item bg-light"><p className="animated">info - информация</p></li>
                    <li className="list-group-item bg-light"><p className="animated">contactus - запросить контакты и обращение и отправить на почту</p></li>
                    <li className="list-group-item bg-light"><p className="animated">chat - разговор с нейросеть, локальной или сетевой, опционально</p></li>
                </ul>
            </section>
            <section>
                <p className="animated">Команду chat реализовывать не обязательно, но будет считаться плюсом</p>
                <p className="animated">Так как приложение тестовое, рекомендуется использовать префикс Test</p>
                <p className="animated">Создавать детали не требуется</p>
            </section>
            <section>
                <p className="text-center animated">При разработке, рекомендуется ознакомится со следующими видео:</p>
                <ul className="list-group">
                    <li className="list-group-item bg-light">
                        <p className="animated">Приложение Telegram бота -<span> </span>
                            <a target="_blank" rel="noreferrer" href="https://rutube.ru/video/3dbcc1c9cdb7ca5101721638faf91092/">видео</a>
                        </p>
                    </li>
                    <li className="list-group-item bg-light">
                        <p className="animated">Публикация приложений показана, например, в данном видео (последний раздел) -<span> </span>
                            <a target="_blank" rel="noreferrer" href="https://rutube.ru/video/d9a24863d02b5f5a9c04fc853ac70f20/">видео</a>
                        </p>
                    </li>
                    <li className="list-group-item bg-light">
                        <p className="animated">Текстовые нейросети -<span> </span>
                            <a target="_blank" rel="noreferrer" href="https://rutube.ru/video/97ed34aa8a50eb2618202192b26942f8/">видео</a>
                        </p>
                    </li>
                    <li className="list-group-item bg-light">
                        <p className="animated">Приложение AIAgent -<span> </span>
                            <a target="_blank" rel="noreferrer" href="https://rutube.ru/video/51fec83a9734dbaa7e76e169a2c49447/">видео</a>
                        </p>
                    </li>
                    <li className="list-group-item bg-light">
                        <p className="animated">Пример создания бота для Telegram -<span> </span>
                            <a target="_blank" rel="noreferrer" href="https://rutube.ru/video/a3cea07e1f9b504baa99325be865ae41/">видео</a>
                        </p>
                    </li>
                </ul>
            </section>
        </div>
    );
};